import { render, staticRenderFns } from "./only-header.vue?vue&type=template&id=74ce9576&"
import script from "./only-header.vue?vue&type=script&lang=ts&"
export * from "./only-header.vue?vue&type=script&lang=ts&"
import style0 from "./only-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports